import React, {useEffect} from "react";
import './Info.scss'
import Header from "../../components/Header";
import Footer from "../../components/Footer";

let img_top = require("../../assets/mushroom/26.webp");

function Company() {
    useEffect(() => {
        document.title = "Geoticket - Informazioni societarie";
    }, []);

    return (
        <div style={{backgroundColor: "#fafafa"}} className={"container-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Informazioni societarie</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container society mt-4 mb-4"}>
                <ul>
                    <li><b>Ragione Sociale:</b>Geoticket S.R.L.</li>
                    <li><b>Sito internet:</b><a href={"https://www.geoticket.it"}>https://www.geoticket.it</a></li>
                    <li><b>Atto Costitutivo:</b>Costituita a Parma il 25 Aprile 2017 presso lo Studio Notarile Canali
                    </li>
                    <li><b>Capitale:</b>euro 3.600,00 i.v.</li>
                    <li><b>Sede legale:</b>Via Lungo Taro Imbriani 4, 43043 Borgotaro (PR)</li>
                    <li><b>Sede operativa:</b>Strada statale 16/BIS 94, 65010 Spoltore (PE)</li>
                    <li><b>Partita Iva:</b>02833700343</li>
                    <li><b>Codice fiscale:</b>02833700343</li>
                    <li><b>Codice SDI:</b>M5UXCR1</li>
                    <li><b>Indirizzo PEC:</b>geoticket@pec.geoticket.it</li>
                    <li><b>Codice Rea:</b>PR-270622</li>
                    <li><b>Iscritta al Registro Imprese di Parma:</b>Sezione ordinaria dal 28/04/2017</li>
                    <li><b>Oggetto sociale:</b>vedi la <a href={"#"}>Visura del Registro Imprese</a></li>
                    <li><b>Attività svolta e spese di sviluppo:</b>Geoticket Srl, è la piattaforma di ticketing online
                        per l’alta montagna che aggrega tutti i servizi degli sport di montagna, con uno strumento
                        digitale avanzato unico sul mercato. <br/><a href={"#"}>Consulta il bilancio di esercizio per i
                            dettagli</a></li>
                    <li><b>Elenco dei soci:</b>vedi la <a href={"#"}>Visura del Registro Imprese</a></li>
                    <li><b>Elenco delle società partecipate:</b><a href={"#"}>Consulta il bilancio di esercizio per i
                        dettagli</a></li>
                    <li><b>Esistenza di relazioni professionali, di collaborazioni o commerciali con incubatori
                        certificati, investitori istituzionali e professionali, Università e centri di ricerca.</b></li>
                    <li><b>Bilancio:</b><a href={"#"}>Consulta il bilancio di esercizio per i dettagli</a></li>

                </ul>
            </div>
            <Footer/>
        </div>
    );
}

export default Company;